import { render, staticRenderFns } from "./Moderation.vue?vue&type=template&id=16ef0514&scoped=true"
import script from "./Moderation.vue?vue&type=script&lang=js"
export * from "./Moderation.vue?vue&type=script&lang=js"
import style0 from "./Moderation.vue?vue&type=style&index=0&id=16ef0514&prod&lang=css"
import style1 from "./Moderation.vue?vue&type=style&index=1&id=16ef0514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef0514",
  null
  
)

export default component.exports